import { render } from "./CommsTable.vue?vue&type=template&id=2d20aed6&scoped=true&lang=pug"
import script from "./CommsTable.vue?vue&type=script&lang=js"
export * from "./CommsTable.vue?vue&type=script&lang=js"

import "./CommsTable.vue?vue&type=style&index=0&id=2d20aed6&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d20aed6"]])

export default __exports__